<template>
    <v-card
    class="documents"
    max-width="100%"
  >

    <v-list two-line subheader>

      <v-list-item
        :key="document.id" v-for="document in documents"
        :onclick="'openUrl(\'' + document.url + '\', false)'"
      >
        <v-list-item-avatar>
        <v-icon color="primary">mdi-folder</v-icon>

        </v-list-item-avatar>

        <v-list-item-content>
            <v-list-item-title v-text="document.name"></v-list-item-title>
            <v-list-item-subtitle v-text="document.type"></v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-action>
          
          <v-btn icon  >
                <v-icon color="primary"> mdi-download</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>

      
    </v-list>
  </v-card>
</template>
<script>
import hubbdata from "@/hubbdata";

export default {
    name: "Documents",
    
    data() {
        return {
        }
    },
    methods: {
       
    },
    computed: {
        documents() {
            return hubbdata.getters.getDocumentsByCategory(this.$route.params.id)
        }
      
    }
}

</script>